
import React from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  TextField,
  Button
} from "@mui/material";

const LoginForm = ({ credentials, setCredentials, onLogin }: any) => (
  <Container maxWidth="xs">
    <Paper sx={{ mt: 8, p: 4 }}>
      <Typography variant="h5" align="center" gutterBottom>
        Login
      </Typography>
      <Box component="form" noValidate onSubmit={e => { e.preventDefault(); onLogin(); }}>
        <TextField
          margin="normal"
          required
          fullWidth
          label="Username"
          value={credentials.username}
          onChange={e => setCredentials({ ...credentials, username: e.target.value })}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          label="Password"
          value={credentials.password}
          onChange={e => setCredentials({ ...credentials, password: e.target.value })}
        />
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>
          Login
        </Button>
      </Box>
    </Paper>
  </Container>
);

export default LoginForm;
